import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../styles/theme/colors';

export const UserDetailModalStyles = {
  Content: styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 3, 3, 3),
    flex: 1,
    overflowY: 'auto',
  })),

  Section: styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3),
  })),

  SectionHeader: styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${colors.grey[200]}`,
  })),

  InfoRow: styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  })),

  StatCard: styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: colors.grey[50],
    border: `1px solid ${colors.grey[200]}`,
    minHeight: 100,
  })),

  Footer: styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${colors.grey[200]}`,
    backgroundColor: colors.grey[50],
  })),

  EditButton: styled(Button)(({ theme }) => ({
    background: 'linear-gradient(to right, #06b6d4, #10b981)',
    color: 'white',
    '&:hover': {
      background: 'linear-gradient(to right, #0891b2, #059669)',
    },
  })),
};
